var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-audit-chart"},[_c('div',{staticClass:"line-chart"},[(_vm.dataExists())?_c('line-chart-widget',{attrs:{"dataProp":_vm.loginAuditChartSection}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }